import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { parse } from 'query-string';
import * as URL from 'url-parse';

import { WindowService } from '../window/window.service';

@Injectable()
export class ReturnUrlService {
    private returnUrlKey = 'returnUrl';

    constructor(private router: Router,
                private windowService: WindowService) {
    }

    private get sessionStorage(): Storage {
        return this.windowService.sessionStorage;
    }

    navigate(): void {
        const returnUrl = this.load();

        if (returnUrl) {
            const url = URL(returnUrl);
            const commands = url.pathname.split('/').filter(i => i);
            const queryParams = parse(url.query);

            // noinspection JSIgnoredPromiseFromCall
            this.router.navigate(commands, {
                queryParams: queryParams
            });
        } else {
            // noinspection JSIgnoredPromiseFromCall
            this.router.navigate(['home']);
        }
    }

    // Stash the 'returnUrl' so it can be reinstated after we get called back to.
    save(): void {
        const returnUrl = this.windowService.window.location.href;
        this.windowService.localStorage.setItem(this.returnUrlKey, returnUrl);
    }

    clear(): void {
        this.windowService.localStorage.removeItem(this.returnUrlKey);
    }

    private load(): string {
        return this.windowService.localStorage.getItem(this.returnUrlKey);
    }
}
